<app-header></app-header>

<div class="register">
 
    <div class="container d-flex justify-content-center align-items-center">
       <div class="form" data-aos="zoom-in" data-aos-duration="2000">
        <h2>إنشاء حساب</h2>
      
        <form [formGroup]="registerForm">
          <div class="form-group">
            <label class="mt-4">الاسم</label>
            <input [ngClass] = "{whiteInput:userName.value.length > 0}"
              formControlName="userName"
              [class.is-invalid]="userName.invalid && userName.touched"
              type="text"
              class="form-control"
            />
            <div *ngIf="userName.errors && userName.invalid && userName.touched">
              <small class="text-danger" *ngIf="userName.errors?.required">
                  مطلوب             </small>
              <small class="text-danger" *ngIf="userName.errors.minlength">
                لا يجب ان يقل الاسم عن 5 حروف
              </small>
              <small *ngIf="userName.errors?.forbiddenName">
                {{ userName.errors?.forbiddenName.value }} غير متاح
              </small>
            </div>
          </div>
      
          <div class="form-group">
            <label>الاسم الأول</label>
            <input [ngClass] = "{whiteInput:firstName.value.length > 0}"
              formControlName="firstName"
              [class.is-invalid]="firstName.invalid && firstName.touched"
              type="text"
              class="form-control"
            />
            <div *ngIf="firstName.errors && firstName.invalid && firstName.touched">
              <small class="text-danger" *ngIf="firstName.errors?.required">
                 مطلوب
              </small>
              <small class="text-danger" *ngIf="firstName.errors.minlength">
                لا يجب ان يقل الاسم الأول عن حرفين
              </small>
            </div>
          </div>
      
          <div class="form-group">
            <label>اسم العائلة</label>
            <input [ngClass] = "{whiteInput:lastName.value.length > 0}"
              formControlName="lastName"
              [class.is-invalid]="lastName.invalid && lastName.touched"
              type="text"
              class="form-control"
            />
            <div *ngIf="lastName.errors && lastName.invalid && lastName.touched">
              <small class="text-danger" *ngIf="lastName.errors?.required">
                مطلوب
              </small>
              <small class="text-danger" *ngIf="lastName.errors.minlength">
                لا يجب ان يقل اسم العائلة عن 3 حروف 
              </small>
            </div>
          </div>
      
          <div class="form-group">
            <label>كلمة السر</label>
            <input [ngClass] = "{whiteInput:password.value.length > 0}"
              formControlName="password"
              type="password"
              class="form-control"              
            />
            <div *ngIf="password.errors && password.invalid && password.touched">
              <small class="text-danger" *ngIf="password.errors?.required">
                مطلوب
              </small>
              <small class="text-danger" *ngIf="password.errors.minlength">
                لا يجب ان تقل كلمة السر عن 8 حروف
              </small>
            </div>
          </div>
      
          <div class="form-group">
            <label>تأكيد كلمة السر</label>
            <input [ngClass] = "{whiteInput:confirmPassword.value.length > 0}"
              [class.is-invalid]="registerForm.errors?.misMatch"
              formControlName="confirmPassword"
              type="password"
              class="form-control"              
            />
            <small *ngIf="registerForm.errors?.misMatch" class="text-danger">
              كلمات السر غير متطابقة
            </small>
          </div>
      
          <div class="form-group">
            <label>البريد الإلكتروني</label>
            <input [ngClass] = "{whiteInput:email.value.length > 0}"
              pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
              type="text"
              [class.is-invalid]="email.invalid && email.touched"
              formControlName="email"
              class="form-control"              
            />
            <small
              class="text-danger"
              [class.d-none]="email.valid || email.untouched"
            >
              البريد الإلكتروني غير صحيح
            </small>
          </div>
      

          <div class="form-group">
            <label> رقم الهاتف</label>
            <input [ngClass] = "{whiteInput:phone.value.length > 0}"
              type="tel"
              formControlName="phone"
              class="form-control "
            />
            <div *ngIf="phone.errors && phone.invalid && phone.touched">
              <small class="text-danger" *ngIf="phone.errors?.required">
                رقم الهاتف مطلوب
              </small>
              <small
                class="text-danger"
                *ngIf="phone.errors.minlength || phone.errors.maxlength"
              >
              مطلوب عشرة أرقام فقط 
              </small>
            </div>
          </div>
          
          <div class="form-group">
            <label>تاريخ الميلاد</label> 
            <input 
              #bDate
              type="date"
              formControlName="birthDate"              
              class="form-control"
            />
          </div>
      
          <!--       
              <div class="form-group">
                  <label>Register as :</label>
                  <select  formControlName="roles"  class="form-control">
                      <option value="Teacher">Teacher</option>
                      <option value="Student">Student</option>
                  </select>
              </div> -->
      
          <div class="form-group">
             <label>النوع </label> 
            <select formControlName="gender" class="form-control ">
              <option value="ذكر" selected>ذكر</option>
              <option value="أنثى">
                أنثى</option>
            </select>
          </div>
       
    
        <div class="form-group">
            <label>دولتك </label>
            <select class="form-control" formControlName="country" (change)="countryChanged()"  >
                <option *ngFor = "let c of countries"  value="{{c._id}}">{{c.name}}</option>
              </select>
        </div>
        
      
        <small class="text-danger bg-warning p-2"> {{registerError}}</small>
      
          <div class="row d-flex justify-content-around">
            <button type="submit" class="btn btn-success mt-4" (click)="submit()">
              تسجيل
            </button>
            <button class="btn btn-warning mt-4" (click)="loadApiData()">
              البيانات الافتراضية
            </button>
          </div>
        </form>
       </div>
      </div>
</div>

        <!-- <div class="form-group">
            <label>SuitableTimes (cairo Time ):</label><br>
            After 8Am<input type="checkbox" (change)="onChangeCheck($event.target.checked)" formControlName="time1"> <br>
            After 3pm<input type="checkbox" (change)="onChangeCheck($event.target.checked)" formControlName="time2" ><br>
            After 8pm<input type="checkbox" (change)="onChangeCheck($event.target.checked)" formControlName="time3" ><br>
            <small class="text-danger"  *ngIf="checkedTimes==0">
                one time required at Least
            </small>
        </div>
 -->        
        

<app-footer></app-footer>